var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 11.5,
    cy: 6.5,
    r: 6.5,
    fill: "#68CFC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.875V6.375C8.75 6.54076 8.81585 6.69973 8.93306 6.81694C9.05027 6.93415 9.20924 7 9.375 7H11.875",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 15.125H4.375C4.04348 15.125 3.72554 14.9933 3.49112 14.7589C3.2567 14.5245 3.125 14.2065 3.125 13.875V5.125C3.125 4.79348 3.2567 4.47554 3.49112 4.24112C3.72554 4.0067 4.04348 3.875 4.375 3.875H8.75L11.875 7V13.875C11.875 14.2065 11.7433 14.5245 11.5089 14.7589C11.2745 14.9933 10.9565 15.125 10.625 15.125Z",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 6.375H6.25",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 10.125H9.375",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 12.625H9.375",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contractIcon.62f37fadf305225cafbf0915d3f61793.svg";
export { ForwardRef as ReactComponent };